import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/services/hosted-emulators/gns3/gns3page.tsx");
